import React from 'react';
import Newsletter from '../newsletter/Newsletter';
import neon_mail from '../assets/neon_mail.jpg';
import './Contact.css';

export default function Contact() {
  return (
    <>
      <Newsletter />
      <main id='contact-main'>
        <div id='contact-rows'>
          <h3>
            Email
          </h3>
          <p className='contact-p'>
            <a href='mailto:hnfisherbooks@protonmail.com?subject=Inquiry'>
              info@hnfisher.com
            </a>
          </p>
        </div>
        <img
          id='contact-image'
          src={neon_mail}
          alt='neon mail sign'
        />
      </main>
    </>
  )
}
